export default __webpack_public_path__ + "static/media/thermometer-half.6878f60c.svg";